import React, { useState } from 'react';
import QuestionLabel from './QuestionLabel';
import { getOptionsFromList } from '../../../lib/Questions';
import { FormPart, optionAttributes, part } from '~/lib/FormCssApi';

const RadioQuestion = ({ label, value, setValue, settings }) => {
    const [name, setName] = useState('id' + Math.random());

    return (
        <div>
            <QuestionLabel label={label} settings={settings} />
            {settings?.options && (
                <div {...part(FormPart.CONTROL)}>
                    {getOptionsFromList(settings.options).map((opt, idx) => (
                        <label
                            key={idx}
                            {...optionAttributes({
                                value: opt,
                                isSelected: value === opt,
                            })}
                            className="flex items-center"
                        >
                            <input
                                {...part(FormPart.OPTION_INPUT)}
                                type="radio"
                                name={name}
                                value={opt}
                                checked={value === opt}
                                onChange={e =>
                                    e.target.checked && setValue(opt)
                                }
                                className="mr-2"
                            />
                            <span {...part(FormPart.OPTION_LABEL)}>{opt}</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RadioQuestion;
